export const API_URL = process.env.API_URL;
export const UPLOAD_SOCIAL_MEDIA_PUBLIC_KEY = process.env.UPLOAD_SOCIAL_MEDIA_PUBLIC_KEY;
